import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Input, Select, Hidden } from '~/components/Form';
import { t } from '~/helpers';
import {
  storeData,
  updateData,
} from '~/store/modules/notafiscalrecebida/actions';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const { client } = useSelector((state) => state.user.profile);
  const { loading, find, params } = useSelector(
    (state) => state.notafiscalrecebida
  );

  const initials = create ? data : { ...find, ...data };

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        statusnfe: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        ...initials,
        ...param,
        idcliente: client,
      };

      if (create) {
        await dispatch(storeData(objSend, params));
      } else {
        await dispatch(updateData(objSend, params));
      }
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    if (!loading) {
      reference.current.setData(initials);
    }
  }, [loading, initials]);

  return (
    <>
      {/* {JSON.stringify(initials)} */}

      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <Input
            disabled
            name="nfnfe"
            label={t('s.operacao.notafiscalrecebida.nfnotafiscalrecebida')}
          />

          <Input
            disabled
            name="qcomnfe"
            label={t(
              's.operacao.notafiscalrecebida.volumenfnotafiscalrecebida'
            )}
          />

          <br />
          <br />

          {(initials.statusnfe === 'C' || initials.statusnfe === 'L') && (
            <Select
              name="statusnfe"
              disabled={
                initials.statusnfe === 'R' || initials.statusnfe === 'F'
              }
              label={t('s.cadastro.contrato.statuscontrato')}
              options={[
                { value: 'L', label: t('s.geral.opcoes.liberado') },
                // { value: 'R', label: t('s.geral.opcoes.EmRecebimento') },
                // { value: 'F', label: t('s.geral.opcoes.Finalizada') },
                { value: 'C', label: t('s.geral.opcoes.cancelado') },
              ]}
            />
          )}

          {(initials.statusnfe === 'R' || initials.statusnfe === 'F') && (
            <Hidden name="statusnfe" key="statusnfe" />
          )}
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
